import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from 'components/Sidebar';

export default function MainLayout() {

    return (
        <Fragment>
            <main>

                <Sidebar />

                <div className='pl-[250px] bg-light'>
                    <Outlet />
                </div>
            </main>
        </Fragment>
    )
}
